import { Injectable } from '@angular/core';
import {
    Router,
    Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { RouteModel } from '../models/route-data.model';

@Injectable()
export class StoryDetailResolver implements Resolve<RouteModel> {
    constructor(private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): RouteModel {
        if (route.queryParams) {
            return <RouteModel>{
                storyId: route.params.storyId,
                isAmplified: route.queryParams.isAmplified,
                storyType: route.queryParams.storyType,
                isFromParent: route.queryParams.isFromParent
            };
        }
        return null;
    }
}
